// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Moldova from '../_raw/flag/icon_flag_moldova.png';

export default () => <img src={Moldova} alt="Moldova" />;
